import { render, staticRenderFns } from "./SubscriptionList.vue?vue&type=template&id=5b4c0c15&scoped=true&"
import script from "./SubscriptionList.vue?vue&type=script&lang=js&"
export * from "./SubscriptionList.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionList.vue?vue&type=style&index=0&id=5b4c0c15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c0c15",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4c0c15')) {
      api.createRecord('5b4c0c15', component.options)
    } else {
      api.reload('5b4c0c15', component.options)
    }
    module.hot.accept("./SubscriptionList.vue?vue&type=template&id=5b4c0c15&scoped=true&", function () {
      api.rerender('5b4c0c15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/subscriptions/SubscriptionList.vue"
export default component.exports